import React from 'react'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import ActionButton from '../../../components/Buttons/ActionButton'
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate'
import BuildIcon from '@mui/icons-material/Build'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import MedicalServices from '@mui/icons-material/MedicalServices'
import SchoolIcon from '@mui/icons-material/School'
import FolderSharedIcon from '@mui/icons-material/FolderShared'
import CampaignIcon from '@mui/icons-material/Campaign'
import Diversity3Icon from '@mui/icons-material/Diversity3'
import GradingIcon from '@mui/icons-material/Grading'
import MedicationIcon from '@mui/icons-material/Medication'
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption'
import RateReviewIcon from '@mui/icons-material/RateReview'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import RuleIcon from '@mui/icons-material/Rule'
import { Grid } from '@mui/material'

const ToDoList = ({ dashboardData }) => {
  const hasTasks = Object.values(dashboardData).some(
    (value) => value > 0 || value === true,
  )

  if (!hasTasks) {
    return null
  }

  return (
    <Box
      display="flex"
      gap={2}
      flexWrap="wrap"
      alignItems="center"
      padding={2}
      component={Paper}
    >
      <Typography variant="title3" textAlign="center">
        To Do:
      </Typography>
      {dashboardData.myUnreadAnnouncements > 0 && (
        <ActionButton
          url="/announcements"
          icon={<CampaignIcon />}
          tooltip={`You have ${dashboardData.myUnreadAnnouncements} announcements to acknowledge`}
          badge={dashboardData.myUnreadAnnouncements}
        />
      )}
      {dashboardData.checkedOutDrugsBags > 0 && (
        <ActionButton
          url="/checkmedsbag"
          icon={<MedicalServices />}
          tooltip={`You have ${dashboardData.checkedOutDrugsBags} drug bags checked out`}
          badge={dashboardData.checkedOutDrugsBags}
        />
      )}
      {dashboardData.myTasks > 0 && (
        <ActionButton
          url="/my-tasks"
          icon={<AssignmentLateIcon />}
          tooltip={`You have ${dashboardData.myTasks} new task${
            dashboardData.myTasks > 1 ? 's' : ''
          }`}
          badge={dashboardData.myTasks}
        />
      )}
      {dashboardData.myTeamTasks > 0 && (
        <ActionButton
          url="/my-tasks"
          icon={<Diversity3Icon />}
          tooltip={`You have ${dashboardData.myTeamTasks} team tasks`}
          badge={dashboardData.myTeamTasks}
        />
      )}
      {dashboardData.myEPCRdrafts > 0 && (
        <ActionButton
          url="/epcr"
          icon={<FolderSharedIcon />}
          tooltip={`You have ${dashboardData.myEPCRdrafts} EPCRs in Drafts`}
          badge={dashboardData.myEPCRdrafts}
        />
      )}
      {dashboardData.myAuditsToReview > 0 && (
        <ActionButton
          url="/my-audits"
          icon={<RuleIcon />}
          tooltip={`You have ${dashboardData.myAuditsToReview} record audit result${
            dashboardData.myAuditsToReview > 1 ? 's' : ''
          } to review`}
          badge={dashboardData.myAuditsToReview}
        />
      )}
      {dashboardData.unreadPolicies > 0 && (
        <ActionButton
          url="/policy-library"
          icon={<AssignmentTurnedInIcon />}
          tooltip={`You have ${dashboardData.unreadPolicies} ${
            dashboardData.unreadPolicies === 1 ? 'policy' : 'policies'
          } to acknowledge`}
          badge={dashboardData.unreadPolicies}
        />
      )}
      {dashboardData.myUnreadSOPs > 0 && (
        <ActionButton
          url="/standard-operating-procedures"
          icon={<GradingIcon />}
          tooltip={`You have ${
            dashboardData.myUnreadSOPs
          } Standard Operating Procedure${
            dashboardData.myUnreadSOPs > 1 ? 's' : ''
          } to review`}
          badge={dashboardData.myUnreadSOPs}
        />
      )}
      {dashboardData.unreadPGDs > 0 && (
        <ActionButton
          url="/pgd-library"
          icon={<MedicationIcon />}
          tooltip={`You have ${dashboardData.unreadPGDs} unread PGD${
            dashboardData.unreadPGDs > 1 ? 's' : ''
          }`}
          badge={dashboardData.unreadPGDs}
        />
      )}
      {dashboardData.unreadCrewVault > 0 && (
        <ActionButton
          url="/crewvault"
          icon={<EnhancedEncryptionIcon />}
          tooltip={`You have ${dashboardData.unreadCrewVault} unread Crew Vault item${
            dashboardData.unreadCrewVault > 1 ? 's' : ''
          }`}
          badge={dashboardData.unreadCrewVault}
        />
      )}
      {dashboardData.myCqcGaps > 0 && (
        <ActionButton
          url="/cqc-centre/my-gaps"
          icon={<FactCheckIcon />}
          tooltip={`You have ${dashboardData.myCqcGaps} CQC gap${
            dashboardData.myCqcGaps > 1 ? 's' : ''
          } assigned to you`}
          badge={dashboardData.myCqcGaps}
        />
      )}
      {dashboardData.myDefects > 0 && (
        <ActionButton
          url="/defects"
          icon={<BuildIcon />}
          tooltip={`You have ${dashboardData.myDefects} defect${
            dashboardData.myDefects > 0 && 's'
          } assigned to you`}
          badge={dashboardData.myDefects}
        />
      )}
      {dashboardData.expiredMandatoryTraining && (
        <ActionButton
          url="/mandatory-training"
          icon={<SchoolIcon />}
          tooltip="You have incomplete or expired mandatory training"
        />
      )}
      {dashboardData.myAppraisalActionNeeded && (
        <ActionButton
          url="/my-appraisals"
          icon={<RateReviewIcon />}
          tooltip="You have an appraisal to complete"
        />
      )}
      {dashboardData.myOccupationalHealthDue && (
        <ActionButton
          url="/my-occupational-health"
          icon={<HealthAndSafetyIcon />}
          tooltip="You have an occupational health screening to complete"
        />
      )}
    </Box>
  )
}

export default ToDoList
